import React from 'react';
import { motion } from 'framer-motion';

export const WaveCard = ({ children, className = "" }) => {
  return (
    <motion.div 
      whileHover={{ y: -8 }}
      className={`bg-white rounded-tl-[3rem] rounded-br-[3rem] rounded-tr-xl rounded-bl-xl shadow-lg border border-[#93e9be]/20 overflow-hidden transition-shadow hover:shadow-2xl ${className}`}
    >
      {children}
    </motion.div>
  );
};